module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embed-container"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-996b74ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Vimeo.vue
// module id = 1024
// module chunks = 0